import axios from "axios";
import logger from "../utils/logger.ts";
import _ from "lodash";

if (!_.isString(import.meta.env.VITE_BASE_URL)) {
  throw new Error(`you should define a REACT_APP_BASE_URL in a ".env"
    or ".env.local" at the root of the project`);
}

let api = axios.create({ baseURL: import.meta.env.VITE_BASE_URL });

export function getTokenListing(page) {
  return api.get(`/tokens/${page}`);
}

export function getFloorPrice() {
  return api.get(`/marketmetrics/floorprice`);
}

export function getCheapestTokenListing(page) {
  return api.get(`/search/${page}?sort_by=cheapest`);
}

export function getLatestTokenListing(page) {
  return api.get(`/tokens/latest/${page}`);
}

export function getLatestMintedGangsters(page) {
  return api.get(`tokens/latest/${page}`);
}

export function getLatestGangsterDetective(type, page) {
  return api.get(`/tokens/popular/${type}/${page}`);
}

export function getPopularNFTBasedOnSkill(page) {
  return api.get(`/tokens/popular/${page}`);
}

export function getTokenDetail(id) {
  const res = api.get(`/token/${id}`);

  return res;
}

export function getAnalyticsData(payload) {
  return api.get(`/data`);
}
export function getTransactionAnalytics() {
  return api.get(`/transactionAnalytics`);
}
export function getDatafromArdrive() {
  return axios.get(
    "https://qvnjpuledstpgonfix5no5wjwjru2awbx32ppdpfde37zciohufq.arweave.net/hVqX0WQcpvM5pUX613bJsmNNAsG-9PeN5Rk3_IkOPQs"
  );
}

export function syncData(txHash) {
  return api.get(`/mint/tx/${txHash}`);
}

export function syncToken(nft_id) {
  return api.get(`/sync/${nft_id}`);
}

export function _syncData(nft_id) {
  return api.get(`/sync/0x${parseInt(nft_id).toString(16)}`);
}

export function getAnalytics() {
  return api.get(`/transactionanalytics`);
}

export function getfilterData() {
  return api.get(`/searchfilters`);
}

export function highestSoldNFT() {
  return api.get("/topsold/1");
}

export function getFilterMarketPlaceData(page, query) {
  return api.get(`/search/${page}${query}`);
}

export function searchBy(page, query) {
  return api.get(`/searchBy/${page}${query}`);
}

// export function reserveNft(payload) {
//   return api.post(`/token/reserve`, payload);
// }

// export function checkNftReservation(address) {
//   return api.get(`/registration/${address}`);
// }

// export function getPopular(page) {
//   return api.get(`/search/${page}?sort_by=popular`);
// }

export function getPopular(page) {
  return api.get(`/tokens/popular/${page}`);
}

export function getRecentlyListed() {
  return api.get(`/marketmetrics/recents`);
}

export function connectWallet(address) {
  return api.get(`wallet/${address}/connect`);
}

export function getActivityLog() {
  return api.get(`v2/activity`);
}

export function setActivityLog(hash) {
  return api.post(`activity`, {
    txhash: hash,
  });
}

export function getFilterLeaderBoardByClass(class_type, page = 1) {
  return api.get(`/tokens/popular_class/${class_type}/${page}`);
}

export function getFilterLeaderBoardByLevel(level, page = 1) {
  return api.get(`/tokens/popular_level/${level}/${page}`);
}
export function get_gg_reward_by_user(address) {
  return api.get(`/rewards/${address}`);
}

export function getRecentStories() {
  return api.get(`/stories/recent`);
}

export function getRecentlySold() {
  return api.get(`/recents/sold`);
}

export function getbOMMreward500kpool(address) {
  return api.get(`bommreward/${address}`);
}

export function getVolumeTradedInCraft() {
  const craft_base_url = "https://api.craft.network/collection/";
  // const craft_gb_url = craft_base_url + import.meta.env.VITE_GANGSTA_SCORE
  const craft_gb_url =
    craft_base_url + "cx384018e03aa8b739472c7a0645b70df97550e2c2";
  return axios.get(craft_gb_url);
}

export const getTransactionCount = async () => {
  try {
    const url =
      "https://tracker.icon.community/api/v1/addresses/details/cx8683d50b9f53275081e13b64fba9d6a56b7c575d";

    const owner_res = await axios.get(url);

    return owner_res.data.transaction_count;
  } catch (e) {
    logger.apiError('getRecentlySold', e);
    return 0;
  }
};
